
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 10 25.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.2 21.5c.1-.4.2-.9.4-1.5L3 11.8c0-.1 0-.2.1-.3v-.3c0-.5-.2-.8-.5-.9-.3-.1-.9-.2-1.8-.2v-1c.7 0 1.8-.1 3.1-.3 1.4-.1 2.3-.3 2.9-.4l1.6-.3-3 10.4c-.2.9-.4 1.5-.5 1.9-.2.9-.3 1.5-.3 1.7s.1.4.2.5c.1.1.3.1.4.1.4 0 .9-.3 1.4-.9.6-.6 1.1-1.3 1.5-2l.8.5C7.6 22 6.7 23.2 6 23.8c-1.1 1-2.3 1.5-3.5 1.5-.7 0-1.3-.2-1.9-.6-.6-.4-.8-1-.8-1.9.2-.2.3-.7.4-1.3zM9.3.7c.5.5.7 1.1.7 1.7s-.2 1.3-.7 1.8c-.5.5-1.2.7-1.9.7s-1.3-.2-1.8-.7c-.5-.5-.8-1.1-.8-1.8s.3-1.3.8-1.7S6.7 0 7.4 0s1.4.2 1.9.7z"}})])
          )
        }
      }
    